// extracted by mini-css-extract-plugin
module.exports = {"snowflake":"SnowFall_snowflake__M4ulb","inner":"SnowFall_inner__s4mvn","snowflakesShake":"SnowFall_snowflakesShake__AQ6D0","snowflakesFall":"SnowFall_snowflakesFall__9gv_i"};